<template>
    <div class="AccountSearch">
        <Row :gutter="4">
            <Col span="4">
                <Select v-model="accountTypeSearchKey" filterable :placeholder="$t('alarms.common.filterByAccountType')"  @on-change="searchAccountType(accountTypeSearchKey)" :transfer="true">
                    <Option value=" " >{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="2">
                <add-or-update-default-alarm-configuration></add-or-update-default-alarm-configuration>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateDefaultAlarmConfiguration from '../default_alarm_configuration/AddOrUpdateDefaultAlarmConfiguration'
    import TableDefaultAlarmConfiguration from '../default_alarm_configuration/TableDefaultAlarmConfiguration'
    var tableDefaultAlarmConfiguration = TableDefaultAlarmConfiguration;
    export default {
        name: 'DefaultAlarmConfigurationSearch',
        components: {
            AddOrUpdateDefaultAlarmConfiguration
        },
        data () {
            return {
                accountTypeSearchKey:'-1',
                accountTypeList:[],
                accountTypeNames:''
            }
        },
        mounted: function(){
            this.getAccountType();
        },
        methods: {
            //查询账户类型
            getAccountType: function(){
                this.$api.account.queryCloudPlatforms("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.accountTypeList = res.data; 
                    })
            },
            // 按账户类型筛选
            searchAccountType: function(){
                eventBus.$emit('accountTypeNames', this.accountTypeSearchKey);
                tableDefaultAlarmConfiguration.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .AccountSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/default_alarm_configuration/DefaultAlarmConfigurationSearch.vue